import { HttpService } from '@/api/shared/http.service'
import { migrateFromV1ToV2 } from '@/api/shared/utils'

import {
  Document,
  DocumentPayload,
  InstructionType,
  UserContactInfoApiType
} from './common.types'

class CommonService extends HttpService {
  getContactInfo() {
    return this.axios.get<UserContactInfoApiType>(this.getPath('/basicinfo'))
  }

  getDocuments(params: DocumentPayload) {
    return this.axios.get<{ data: Document[] }>(
      migrateFromV1ToV2(this.getPath('/documents')),
      {
        params
      }
    )
  }

  getInstructionTypes(projectId: string) {
    return this.axios.get<{ data: InstructionType[] }>(
      this.getPath('/instructionTypes'),
      {
        params: { projectId }
      }
    )
  }

  getDocumentHtml(url: string) {
    return this.axios.get<{ link: string }>(url)
  }

  getDocumentById(id: string) {
    return this.axios.get<{ link: string }>(this.getPath(`/documents/${id}`))
  }
}

export const CommonServiceSingleton = new CommonService('api/v1/staticData')
export { CommonServiceSingleton as CommonService }
